import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  root: {
    flexDirection: 'row',
  },
  content: {
    flex: 1,
    flexDirection: 'column',
    width: '100%'
  },
  arrowWrapper: {
    flexDirection: 'column',
    justifyContent: 'center',
  },
  arrow: {
    marginLeft: 5,
  },
  absoluteArrow: {
    position: 'absolute',
    right: 0,
    bottom: 15
  }
});
